import {css} from '@emotion/react'

const defaultGetText = (a) => a

const cssViewLongText = css({
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    //whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
})

const ViewLongText = ({
    getText = defaultGetText,
    maxRows,
    value,
    ...props
}) => {
    const text = (() => {
        if (value || 0 === value) {
            return getText(value)
        }
        else {
            return ''
        }
    })()

    const style = {
        WebkitLineClamp: maxRows ?? 'none',
    }

    return (
        <div
            css={cssViewLongText}
            style={style}
            title={text}
            {...props}
        >
            {text}
        </div>
    )
}

export default ViewLongText
